import { PowerOfExpData, PowerOfExpRegion } from '@tenants/types/tenant';
import { joinExpCaPaths, joinExpUsPaths, Namespaces } from 'types/locales';

export function createPowerOfExpData(namespace: typeof Namespaces.JOIN_EXP_US | typeof Namespaces.JOIN_EXP_CA): PowerOfExpData {

  const powerOfExp_title: joinExpCaPaths | joinExpUsPaths = `${namespace}:powerOfExp.title`;
  const powerOfExp_expExplainedHashtag: joinExpCaPaths | joinExpUsPaths = `${namespace}:powerOfExp.expExplainedHashtag`;
  const powerOfExp_section1_title: joinExpCaPaths | joinExpUsPaths = `${namespace}:powerOfExp.section1.title`;
  const powerOfExp_section1_info: joinExpCaPaths | joinExpUsPaths = `${namespace}:powerOfExp.section1.info`;
  const powerOfExp_section1_timing: joinExpCaPaths | joinExpUsPaths = `${namespace}:powerOfExp.section1.timing`;
  const powerOfExp_section1_button: joinExpCaPaths | joinExpUsPaths = `${namespace}:powerOfExp.section1.button`;
  const powerOfExp_section1_signMeUpHref: joinExpCaPaths | joinExpUsPaths = `${namespace}:powerOfExp.section1.signMeUpHref`;
  const powerOfExp_section1_image: joinExpCaPaths | joinExpUsPaths = `${namespace}:powerOfExp.section1.image`;
  const powerOfExp_section1_imageAlt: joinExpCaPaths | joinExpUsPaths = `${namespace}:powerOfExp.section1.imageAlt`;

  const powerOfExp_section2_title_mobile: joinExpCaPaths | joinExpUsPaths = `${namespace}:powerOfExp.section2.title.mobile`;
  const powerOfExp_section2_title_desktop: joinExpCaPaths | joinExpUsPaths = `${namespace}:powerOfExp.section2.title.desktop`;
  const powerOfExp_section2_info: joinExpCaPaths | joinExpUsPaths = `${namespace}:powerOfExp.section2.info`;
  const powerOfExp_section2_button_mobile: joinExpCaPaths | joinExpUsPaths = `${namespace}:powerOfExp.section2.button.mobile`;
  const powerOfExp_section2_button_desktop: joinExpCaPaths | joinExpUsPaths = `${namespace}:powerOfExp.section2.button.desktop`;
  const powerOfExp_section2_image: joinExpCaPaths | joinExpUsPaths = `${namespace}:powerOfExp.section2.image`;
  const powerOfExp_section2_imageAlt: joinExpCaPaths | joinExpUsPaths = `${namespace}:powerOfExp.section2.imageAlt`;

  const powerOfExp_presentation_modal_title: joinExpCaPaths | joinExpUsPaths = `${namespace}:powerOfExp.presentation.modal.title`;
  const powerOfExp_presentation_modal_downloadButton: joinExpCaPaths | joinExpUsPaths = `${namespace}:powerOfExp.presentation.modal.downloadButton`;

  const regions: PowerOfExpRegion[] = [
    {
      id: 'us',
      title: `${namespace}:powerOfExp.presentation.modal.us.title`,
      imageSrc: `${namespace}:powerOfExp.presentation.modal.us.imageSrc`,
      url: `${namespace}:powerOfExp.presentation.modal.us.url`,
    },
    {
      id: 'ca',
      title: `${namespace}:powerOfExp.presentation.modal.ca.title`,
      imageSrc: `${namespace}:powerOfExp.presentation.modal.ca.imageSrc`,
      url: `${namespace}:powerOfExp.presentation.modal.ca.url`,
    },
    {
      id: 'international',
      title: `${namespace}:powerOfExp.presentation.modal.international.title`,
      imageSrc: `${namespace}:powerOfExp.presentation.modal.international.imageSrc`,
      url: `${namespace}:powerOfExp.presentation.modal.international.url`,
    },
  ];

  return {
    title: powerOfExp_title,
    expExplainedHashtag: powerOfExp_expExplainedHashtag,
    section1: {
      title: powerOfExp_section1_title,
      info: powerOfExp_section1_info,
      timing: powerOfExp_section1_timing,
      button: powerOfExp_section1_button,
      signMeUpHref: powerOfExp_section1_signMeUpHref,
      image: powerOfExp_section1_image,
      imageAlt: powerOfExp_section1_imageAlt,
    },
    section2: {
      title: {
        mobile: powerOfExp_section2_title_mobile,
        desktop: powerOfExp_section2_title_desktop,
      },
      info: powerOfExp_section2_info,
      button: {
        mobile: powerOfExp_section2_button_mobile,
        desktop: powerOfExp_section2_button_desktop,
      },
      image: powerOfExp_section2_image,
      imageAlt: powerOfExp_section2_imageAlt,
    },
    presentation: {
      modal: {
        title: powerOfExp_presentation_modal_title,
        downloadButton: powerOfExp_presentation_modal_downloadButton,
        regions,
      },
    },
  };
}